import React, { useEffect } from 'react';
import styles from './Stats.module.css';
import useWalletStore from '../../providers/walletStore';
import { useSupabaseStore } from '../../providers/supabaseStore';

const Stats = () => {
  const { wallet } = useWalletStore();
  const { points, fetchPoints } = useSupabaseStore();

  useEffect(() => {
    if (wallet?.address) {
      fetchPoints(wallet.address);
    }
  }, [wallet?.address, fetchPoints]);

  const handleMint = () => {
    // TODO: Implement mint functionality
    console.log('Mint clicked');
  };

  return (
    <div className={styles.statsSection}>
      <div className={styles.userInfoSection}>
        <div className={styles.userAvatar}></div>
        <div className={styles.userDetails}>
          <div className={styles.userHeader}>
            <div className={styles.nameAndLevel}>
              <div className={styles.userName}>
                {wallet?.address ? wallet.address.slice(0, 6) : '-'}
              </div>
              <span className={styles.levelBadge}>Lv1</span>
            </div>
            <div className={styles.tokenRow}>
              <div className={styles.tokenInfo}>
                <span className={styles.tokenIcon}>🎫</span>
                <span>0</span>
                <span className={styles.tokenLabel}>NFT for rewards</span>
              </div>
              <button className={styles.mintButton} onClick={handleMint}>
                Mint
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <span>Points</span>
          <span className={styles.statValue}>{points}</span>
        </div>
        <div className={styles.statCard}>
          <span>Rank</span>
          <span className={styles.statValue}>#1</span>
        </div>
        <div className={styles.statCard}>
          <span>Referrals</span>
          <span className={styles.statValue}>0</span>
        </div>
      </div>
    </div>
  );
};

export default Stats;
